import React from 'react';
import parse from 'html-react-parser';
import { introGuide } from './intro';

const IntroGuide: React.FC = () => {
  return <>{parse(introGuide)}</>;
};

export { IntroGuide };
